module.exports = __webpack_public_path__ + "img/9.222fc913.jpg";